const dealersData = {
  dealers: [
    { label: "Armstrong's Citroën Auckland", code: 'ACGLN' },
    { label: "Armstrong's Citroën East Auckland", code: 'AUK-01597' },
    { label: 'North Shore Citroën', code: 'ACNTS' },
    { label: "Armstrong's Citroen East Auckland", code: 'ACEAK' },
    { label: 'Southern Autos Manukau Citroën', code: 'ACMAN' },
    { label: 'Duncan & Ebbett Citroën', code: 'ACHAM' },
    { label: 'Shorland Citroën Tauranga', code: 'ACTGA' },
    { label: 'Hawkes Bay Citroën', code: 'ACHKB' },
    { label: "Armstrong's Citroën Christchurch", code: 'ACCHC' },
    { label: 'Southern Motor Court Dunedin', code: 'ACDUN' },
    { label: "Armstrong's Citroën Lower Hutt", code: 'ACWLH' }
  ]
}

export default dealersData
